import styled from 'styled-components'

type ButtonProps = {
  float?: string
}

/** BUTTONS  */
const Button = styled.button<ButtonProps>`
  border-radius: 0.15rem;
  margin: 5px 0 40px 0;
  appearance: button;
  float: ${props => props.float ? props.float : 'right'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer '};
  transition: all 0.25s ease-out, color 0.25s ease-out;
  transition-duration: 0.15s;
  transition-property: all;
  transition-timing-function: ease-in-out;
  &:focus {
    outline: 0;
    ${props => props.disabled ? 'border-style: dashed; border-color: #909294;' : ''};
  }
  &:hover {
    ${props => props.disabled ? '': 'transform: scale(1.02)'};
  }
  &::-moz-focus-inner {
    border: 0;
  }
`

const PrimaryButton = styled(Button)`
  background-color: ${props => props.disabled ? '#dadbdb' : '#e01719'};
  color: ${props => props.disabled ? '#6b6d71' : '#fff'};
  fill: ${props => props.disabled ? '#6b6d71' : '#fff'};
  width: 175px;
  height: 42px;
  border: none;
  padding: 6px;
  &:hover, &:focus {
    background-color: ${props => props.disabled ? '#dadbdb' : '#af1214'};
  }
  &:focus {
    ${props => props.disabled ? 'border-width: 3px' : 'border: 6px solid #99d3f7'};
    ${props => props.disabled ? '' :'border-radius: 12px;'};
  }
  @media (max-width: 468px) {
    width: 50%;
    margin: auto;
    float: none;
    margin-bottom: 40px;
    margin-left: 25%;
  }
`

const SecondaryButton = styled(Button)`
  background-color:  #FFFFFF;
  color: ${props => props.disabled ? '#cccccc' : '#e01719'};
  fill: ${props => props.disabled ? '#cccccc' : '#e01719'};
  width: 18%;
  height: 42px;
  border: 0.15rem solid ${props => props.disabled ? '#b5b6b8' : '#e01719'};
  float: ${props => props.float ? props.float : 'none'};
  padding: 0.45rem;
  &:hover, &:focus {
    background-color:  ${props => props.disabled ? 'none' : '#cce9fb'};
    ${props => props.disabled ? '' : 'color: #af1214'};
  }
  &:hover {
    ${props => props.disabled ? 'border-width: 3px' : 'border-color: #af1214'};
  }
  @media (max-width: 468px) {
    width: 50%;
    margin-left: 25%;
    float: none;
  }
`

const HelpIcon = styled.span`
  display: inline-block;
`

const IconButton = styled.button`
  color: #007da3;
  fill: #007da3;
  background: transparent;
  appearance: button;
  border: 0;
  border-radius: 0.15rem;
  font-size: 0;
  line-height: 0;
  text-align: center;
  padding: 0.6rem;
  cursor: pointer;
  transition: all 0.25s ease-out, color 0.25s ease-out;
  transition-duration: 0.15s;
  transition-property: all;
  transition-timing-function: ease-in-out;
  &:focus, &:hover {
    background: #cce9fb;
    outline: 0;
  }
  &:active {
    background: #99d3f7;
    color: #007395;
    fill: #007395;
  }
  &::-moz-focus-inner {
    border: 0;
  }
`
/** END BUTTONS */

/** CARDS AND CONTAINERS */
const Card = styled.div`
  background-color: #FFFFFF;
  max-width: 100%;
  padding: 10px 20px 40px 20px;
  border: 1px solid silver;
  @media (max-width: 768px) {
    border: none;
    margin-left: 0;
    margin-bottom:0px !important;
  }

`

const CardHeader = styled.h2`
  text-align: left;
  margin: 10px 0 5px;
  display: inline-block;
`
const ButtonContainer = styled.div`
  padding-top:30px;
  @media (max-width: 468px) {
    background-color:#fff;
  }
`
/** END CARDS AND CONTAINERS */

/** ERRORS */
const Error = styled.div`
  color: #CC2D30;
  text-align: center;
  margin-bottom: 10px;
  font-size: 0.875rem;
  font-weight: normal;
`

const FieldError = styled.div`
  color: #CC2D30;
  margin-bottom: 10px;
  padding-top: 4px;
  height: 24px;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  margin-left: 31%;
  width: 100%;
  @media (max-width: 668px) {
    margin-left:0%;
  }
`
/** END ERRORS */

const PageInformation = styled.p`
  text-align: left;
  padding-bottom: 10px;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #292b2c;
`

const Select = styled.select<{ error?: boolean }>`
  border: solid 1px ${props => props.error ? '#CC2D30' : ' #CCCED2'};
  background: #FFFFFF;
  color: #313235;
  font-size: 17px;
  line-height: 1.5;
  border-radius: 0;
  width: 100%;
  height: 50px;
  margin: 0;
  padding: 10px 10px 10px 8px;
  appearance: none;
  -webkit-appearance: none;
  -ms-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  background-image: url(img/Dropdown_Arrow.png);
  background-position: right 10px center;
  background-repeat: no-repeat;
  ::-ms-expand {
    display: none;
  }
  &:focus {
    box-shadow: 0px 0px 3px 1px #007cca;
    ${props => props.disabled ? 'border-style: dashed': ''};
    outline: 0;
  }
  &:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
  }
`

const Textbox = styled.input<{ error?: boolean }>`
  border: solid 1px ${props => props.error ? '#CC2D30' : ' #CCCED2'};
  background: #FFFFFF;
  color: ${props => props.disabled ? '#A9AAAD' : '#313235'};
  border-radius: 0;
  width: 100%;
  max-width: 100%;
  min-height: 50px;
  margin: 0;
  box-sizing: border-box;
  padding: 8px;
  margin-left: 31%;
  &:focus {
    ${props => props.disabled ? 'border-style: dashed': ''};
    box-shadow: 0px 0px 3px 1px #007cca;
    outline: 0;
  }
  @media (max-width: 668px) {
    margin-left:0%;
  }
`
const TravelersLogon = styled.img`
  width: 131px;
  height: 27px;
  object-fit: contain;
`

export {
  Button,
  ButtonContainer,
  Card,
  CardHeader,
  Error,
  FieldError,
  HelpIcon,
  IconButton,
  PageInformation,
  PrimaryButton,
  SecondaryButton,
  Select,
  Textbox,
  TravelersLogon
}
